/**
 * Geolocation analytics helpers — coordinates are rounded before persistence.
 */
const DEFAULT_PRECISION = 3;

export function coarsenCoordinate(value, precision = DEFAULT_PRECISION) {
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  const factor = 10 ** precision;
  return Math.round(num * factor) / factor;
}

export function coarsenCoordinates(latitude, longitude, precision = DEFAULT_PRECISION) {
  return {
    latitude: coarsenCoordinate(latitude, precision),
    longitude: coarsenCoordinate(longitude, precision),
  };
}

export function buildGeolocationAnalyticsPayload({
  slug,
  latitude,
  longitude,
  accuracyMeters = null,
  method = "gps",
  errorCode = null,
  precision = DEFAULT_PRECISION,
} = {}) {
  const payload = {
    slug: slug || null,
    method,
  };

  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    Object.assign(payload, coarsenCoordinates(latitude, longitude, precision));
  }

  if (Number.isFinite(accuracyMeters)) {
    payload.accuracyMeters = Math.round(accuracyMeters);
  }

  if (errorCode != null) {
    payload.errorCode = errorCode;
  }

  return payload;
}
